

/**
 * The configuration service respons
 */
export type ResponseBase = {
    Status: string,
    StatusMessage?: string,
    Result: any
}